import { ManHoursArray } from '../../../types/manhour/ManHourGetResponse';
import { formatProjectName } from '../../../utils/formatProjectName';
import { formatYmDisplay } from '../../../utils/formatYmDisplay';

interface RenderManHourRowProps {
  item: ManHoursArray;
}

const RenderManHourRow = ({ item }: RenderManHourRowProps) => {
  return (
    <>
      <td>{item.employeeCode}</td>
      <td>{item.employeeName}</td>
      <td>{formatProjectName(item.projectName)}</td>
      <td>{formatYmDisplay(item.month)}</td>
      <td>{item.totalManHours}</td>
    </>
  );
};

export default RenderManHourRow;
